import type { ReviewCard as ReviewCardType } from "./reviewTypes";
import ReviewCardsColumn from "./ReviewCardsColumn";

export type SectionHeaderWithReviewsProps = {
  title: string;
  headingId: string;
  onSuggest: () => void;
  cards?: ReviewCardType[];
  onEdit?: (card: ReviewCardType) => void;
  onDelete?: (card: ReviewCardType) => void;
};

export function SectionHeaderWithReviews({
  title,
  headingId,
  onSuggest,
  cards,
  onEdit,
  onDelete,
}: SectionHeaderWithReviewsProps) {
  if (cards && cards.length > 0) {
    return (
      <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,320px)] lg:items-start">
        <div className="group relative">
          <h2
            id={headingId}
            className="scroll-mt-24 text-3xl font-semibold leading-tight tracking-tight text-black"
          >
            {title}
          </h2>
          <button
            type="button"
            onClick={onSuggest}
            className="absolute right-2 top-2 rounded-full border border-beige-200 bg-white px-2 py-0.5 text-[10px] font-medium text-black shadow-sm opacity-0 transition-opacity group-hover:opacity-100"
          >
            Suggest
          </button>
        </div>
        <ReviewCardsColumn cards={cards} onEdit={onEdit} onDelete={onDelete} />
      </div>
    );
  }

  return (
    <div className="group relative">
      <h2
        id={headingId}
        className="scroll-mt-24 text-3xl font-semibold leading-tight tracking-tight text-black"
      >
        {title}
      </h2>
      <button
        type="button"
        onClick={onSuggest}
        className="absolute right-2 top-2 rounded-full border border-beige-200 bg-white px-2 py-0.5 text-[10px] font-medium text-black shadow-sm opacity-0 transition-opacity group-hover:opacity-100"
      >
        Suggest
      </button>
    </div>
  );
}

export default SectionHeaderWithReviews;
